export default class ChargesListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, 
    GlobalConfig, Requests, $filter, $rootScope, WorkPlanIndicatorSrv, $sessionStorage) {
    var chargesListVm = this
    var _timeout;
    const listuser = JSON.parse($cookies.get('currentUser'))
    const active = GlobalConfig.generals.active

    chargesListVm.charges = []
    chargesListVm.viewLoaded = false
    
    chargesListVm.planningFinish = true
    chargesListVm.idCharge = 0
    chargesListVm.feedback = 0
    chargesListVm.sr = ''
    chargesListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
    chargesListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')        

    chargesListVm.updateView = updateView
    chargesListVm.backgroundGrad = backgroundGrad
    chargesListVm.editObs = editObs
    chargesListVm.changeColorBall = changeColorBall
    chargesListVm.getcreatedOrEdit = getcreatedOrEdit
    chargesListVm.getGeneralsWorkplan = getGeneralsWorkplan    
    chargesListVm.validateSearch = validateSearch
    chargesListVm.bitacora = bitacora
    chargesListVm.dt_start = $cookies.get('wp_start')
    chargesListVm.dt_end = $cookies.get('wp_end')
    chargesListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    chargesListVm.$sessionStorage = $sessionStorage

    function validateSearch() {
      return $filter('filter')(chargesListVm.charges, chargesListVm.search)
    }

    activate()


    function updateView () {
      chargesListVm.viewLoaded = false
      if(_timeout){ //if there is already a timeout in process cancel it
        $timeout.cancel(_timeout);
       }
    _timeout =$timeout(() => {
        chargesListVm.viewLoaded = true
        _timeout = null;
      }, 1)
    }
    
    function backgroundGrad (index) {
      let result = 'grad-oblique-'
      chargesListVm.ind = index % 4

      switch (index % 4) {
        case 0:
          return result + 'negro-dark'
        case 1:
          return result + 'azul'
        case 2:
          return result + 'teal'
        case 3:
          return result + 'deep-orange'
        default:
          return result + 'negro-dark'
      }
    }


    function activate () {
      
      chargesListVm.isFeedback = listuser.isFeedback
      let post = {
        teacherId: listuser.teacherId,
        wp_start:  chargesListVm.dt_start,
        wp_end:    chargesListVm.dt_end
      }

      if(chargesListVm.workPlanGeneralList != undefined){
        chargesListVm.status = chargesListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        chargesListVm.stages = chargesListVm.workPlanGeneralList.stages
        chargesListVm.feedback = chargesListVm.status.feedbackReviewed
        chargesListVm.workplanTeacherId = chargesListVm.status.workplanTeacherId
        isPlanning(chargesListVm.status, chargesListVm.stages)

        if(chargesListVm.feedback && !chargesListVm.planningFinish){
          getDelegationChargesReject(post)
        }else{
          getDelegationCharges(post)
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(chargesListVm.feedback && !chargesListVm.planningFinish){
            getDelegationChargesReject(post)
          }else{
            getDelegationCharges(post)
          }
        })
      }
    }

  function getDelegationCharges(post){
    WorkPlanSrv.getDelegationCharges.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.data)
          }
        },
        data => {
          console.log(data)
        }
      )
  }

  function getDelegationChargesReject(post){
    WorkPlanSrv.getDelegationChargesReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.data)
          }
        },
        data => {
          console.log(data)
        }
      )
  }

  function loadData (data) {
      chargesListVm.charges = data.map(chargeList=>{
        chargeList.idCharge = chargesListVm.idCharge
        chargesListVm.idCharge++
        return chargeList
      })
      console.log(chargesListVm.charges)
      for (var i = chargesListVm.charges.length - 1; i >= 0; i--) {
        //chargesListVm.charges[i].chargeDateStart = moment(chargesListVm.charges[i].chargeDateStart).format('DD/MM/YYYY')
        if(chargesListVm.charges[i].chargeObservation==null || chargesListVm.charges[i].chargeObservation==''){
            chargesListVm.charges[i].chargeObservation = GlobalConfig.charges.emptyDescriptionMessage
        }
        if(chargesListVm.charges[i].hoursPlanned== null){
          chargesListVm.charges[i].hoursPlanned = 0
        }
      }
      updateView()
    }

    function editObs(charge) { 
     let editCharge = charge

      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
            var editObsVm = this
            editObsVm.per = editCharge.percentageDedication
            editObsVm.obs = editCharge.chargeObservation
            editObsVm.validateForm = validateForm
            editObsVm.showErrorMessages = showErrorMessages
            editObsVm.hasError = hasError
            editObsVm.nameButton = editCharge.hoursPlanned > 0 ? 'Modificar' : 'Agregar'

          
              if(editCharge.chargeObservation == GlobalConfig.charges.emptyDescriptionMessage){
                editObsVm.obs = ''
                editObsVm.per = 0
              }else{
                editObsVm.obs = editCharge.chargeObservation
                editObsVm.per = editCharge.percentageDedication
              }
            editObsVm.addActivityPlanningAcademic = addActivityPlanningAcademic

            editObsVm.close = function() { 
              $mdDialog.hide()
            }
            
            function validateForm(form){
              return form.$invalid
            }

            function showErrorMessages(input) {
              return input.$dirty || input.$touched
            }

            function hasError (input) {
              if (input.$invalid && (input.$dirty || input.$touched)) {
                return 'has-error'
              }
            }

            function createJson(editCharge){              
              let post = {
                teacherId: listuser.teacherId,
                workplanId: listuser.workplanId,
                userId: listuser.id,
                isFeedbackActivity: chargesListVm.isFeedback
              }

              var assignment = {
               teacherId: post.teacherId,
               workplanId: post.workplanId,
               workplanTeacherChargeId: editCharge.workplanTeacherChargeId,
               description: editObsVm.obs,
               percentage: editObsVm.per,
               userId: post.userId,
               activityId:27,
               wp_start: chargesListVm.dt_start,
               wp_end: chargesListVm.dt_end,
               workplanTeacherActivityId: editCharge.workplanTeacherActivityId
              }

              WorkPlanSrv.addActivityPlanningAcademic.save(assignment).$promise.then((dataReturn) => {
                if (dataReturn.status) {
                  WorkPlanIndicatorSrv.setVariable(true)
                  let idx = chargesListVm.charges.indexOf(editCharge)

                    if(!assignment.workplanTeacherActivityId)
                      $rootScope.addchargesAssigned = true
                  
                  chargesListVm.charges[idx].hoursPlanned = dataReturn.hours
                  charge.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
                  editObsVm.close()
                }else{
                  console.log("Comunication problem with server")
                }
              })
            }

            function addActivityPlanningAcademic(){
              $scope.disablebutton = false
              createJson(editCharge)
              editCharge.percentageDedication = editObsVm.per
              editCharge.chargeObservation = editObsVm.obs              
            }
        }],
        controllerAs: "editObsVm",
        template: require('./chargesChangeObsModal.html'),
        clickOutsideToClose:false
      })
    }

    function changeColorBall(charge){
      var color = 'gris-darker'
      if(charge.percentageDedication > 0)
        color = 'amarillo'

      return color
    }

    function getcreatedOrEdit(charge){
      if(charge.hoursPlanned > 0)
        return 'Editar'
      else
        return 'Agregar'
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          chargesListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          chargesListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          chargesListVm.stages = dataReturn.data.stages
          chargesListVm.feedback = chargesListVm.status.feedbackReviewed
          chargesListVm.workplanTeacherId = chargesListVm.status.workplanTeacherId
          isPlanning(chargesListVm.status, chargesListVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      chargesListVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          chargesListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == active){        
          chargesListVm.planningFinish = true
          if (chargesListVm.startDateReview < chargesListVm.currentDate || status.reviewedFinish == active){
            chargesListVm.planningFinish = true
          }else if (status.reviewedReject == active){
            chargesListVm.planningFinish = false
          }
        } else {
          chargesListVm.planningFinish = false
        }
      }else{
        chargesListVm.planningFinish = true
      }

      $scope.classPlanning = (chargesListVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.positionsByDelegation,
        workplanTeacherId: chargesListVm.workplanTeacherId
      }
      entries.title = 'Cargos por Delegación'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }//FIN DEL CONSTRUCTOR
      preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey)
        event.preventDefault()
      return;     
    }
}

ChargesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog',
 '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$filter', '$rootScope', 'WorkPlanIndicatorSrv', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/charges/list/chargesListCtrl.js